import Vue from 'vue'

Vue.use({
    install() {
        Vue.prototype.$loginCallback = function () {
            if(this.$route.query._token)
            {
                // Save the token.
                this.$store.dispatch('auth/saveToken', {
                    token: this.$route.query._token,
                    remember: true
                })

                // Fetch the user.
                this.$store.dispatch('auth/fetchUser')
                this.$router.replace({query:{}})
                /*setTimeout(function () {
                    this.$router.go(this.$route.path)
                }.bind(this) , 920);*/

            }

            if(this.$route.query.hasOwnProperty('error_n'))
            {
                window.location.href = `${this.$route.query.error_n != 126 ? '':'/blocked'}/?error_no=${this.$route.query.error_n}&message=${this.$route.query.message}`;
            }

            if(this.$route.query.hasOwnProperty('error_no'))
            {
                if (this.$route.query.error_no != 126)
                    this.$q.notify({
                        color: 'warning',
                        icon: 'warning',
                        message: this.$T(this.$route.query.message),
                        detail: "",
                        position: 'top',
                        timeout: 5000,
                    })
            }

            this.$router.replace({query:{}});
        }
    }
})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/loginCallback.js